<ng-container *ngIf="loaded && featuresInit">
  <router-outlet >
  </router-outlet>
</ng-container>
<app-loader></app-loader>
<app-toast></app-toast>
<app-prebootstrap-loader *ngIf="!loaded"></app-prebootstrap-loader>
<app-promotion-popup></app-promotion-popup>
<app-nps-rating [minRatingMandaroty]="npsOptions.minRatingMandaroty" *ngIf="showNpsRating"
  (close)="closeNpsRating($event)"></app-nps-rating>